import type { GalleryV1Attributes } from '@/features/gallery-v1/gallery-v1-type';

import styles from './gallery-additional-image-layer.module.scss';

export default function GalleryAdditionalImageLayer(props: {
    gallery: GalleryV1Attributes['gallery'];
    imageCount: number;
    index: number;
}) {
    const { gallery, imageCount, index } = props;

    if (props.gallery.length <= imageCount || index !== imageCount - 1) {
        return null;
    }
    return (
        <>
            <div className={`absolute-full ${styles.additionalImageContainer}`} />
            <div className={`absolute-full flex-center ${styles.additionalImageCount}`}>
                {'+' + (gallery.length - imageCount)}
            </div>
        </>
    );
}
